import { createSelector } from "@reduxjs/toolkit";
import { ReportFactory } from "../../types/state";
import { RootState } from "src/store/rootReducer";
import { NameSpace } from "../../const";

export const getDataReportFactory = createSelector(
  (state: RootState) => state.gop[NameSpace.ReportFactory],
  (state: ReportFactory) => state.data
);

export const getFetchingStatusReportFactory = createSelector(
  (state: RootState) => state.gop[NameSpace.ReportFactory],
  (state: ReportFactory) => state.fetchingStatusReportFactory
);

export const getDataReportFactoryError = createSelector(
  (state: RootState) => state.gop[NameSpace.ReportFactory],
  (state: ReportFactory) => state.error
);
